<template>
  <div class="vac-banner">
    <picture class="vac-banner-picture">
      <source media="(max-width: 767px)" :srcset="images.img375" />
      <source media="(max-width: 1023px)" :srcset="images.img768" />
      <source media="(max-width: 1279px)" :srcset="images.img1024" />
      <source media="(max-width: 1439px)" :srcset="images.img1280" />
      <source media="(max-width: 1919px)" :srcset="images.img1440" />
      <img
        class="vac-banner-image"
        :src="images.img1920"
        :alt="$t('vacancies.menu')"
      />
    </picture>
    <div class="vac-banner-text">
      <div class="vac-banner-title">{{ $t('vacancies.menu') }}</div>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/img/vacancies/Rev-Commercial-1307.jpg';

export default {
  name: 'VacanciesBanner',
  data() {
    return {
      images: {
        img375: banner,
        img768: banner,
        img1024: banner,
        img1280: banner,
        img1440: banner,
        img1920: banner,
      },
    };
  },
};
</script>

<style scoped>
.vac-banner {
  position: relative;
  width: 100%;
  height: 140vw;
  overflow: hidden;
}

@media screen and (min-width: 580px) {
  .vac-banner {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .vac-banner {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .vac-banner {
    height: calc(100vh - 192px);
  }
}

.vac-banner-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.vac-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.vac-banner-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  .vac-banner-text {
    width: 50%;
    align-items: center;
    padding: 0 40px;
  }
}

@media screen and (min-width: 1440px) {
  .vac-banner-text {
    padding: 0 80px;
  }
}

@media screen and (min-width: 1920px) {
  .vac-banner-text {
    padding: 0 120px;
  }
}

.vac-banner-title {
  line-height: 1.05;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 32px;
}

@media screen and (min-width: 768px) {
  .vac-banner-title {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .vac-banner-title {
    font-size: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .vac-banner-title {
    font-size: 66px;
  }
}
</style>
